import { render, staticRenderFns } from "./AdvicesCategories.vue?vue&type=template&id=b5b5efe4&scoped=true&"
import script from "./AdvicesCategories.vue?vue&type=script&lang=js&"
export * from "./AdvicesCategories.vue?vue&type=script&lang=js&"
import style0 from "./AdvicesCategories.vue?vue&type=style&index=0&id=b5b5efe4&lang=sass&scoped=true&"
import style1 from "./AdvicesCategories.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5b5efe4",
  null
  
)

export default component.exports